import { ChainSwitcher } from './ChainSwitcher'
import { ConnectButton } from './ConnectButton'
import { RoleBadge } from './RoleBadge'
import { ThemeToggle } from './ThemeToggle'

export function Topbar() {
    return (
        <div className="border-border bg-background flex h-14 items-center justify-end gap-3 border-b px-6">
            <RoleBadge />
            <ChainSwitcher />
            <ThemeToggle />
            <ConnectButton />
        </div>
    )
}
